import type { ApiPreferredListingType } from '#/api/types/ApiPreferredListingType';

export function transformPreferredListingTypesOnChange(
  values: ApiPreferredListingType[],
): ApiPreferredListingType[] {
  // User had "NOT_HERE_TO_POST" selected, then selected something else
  if (values.length > 1 && values[0] === 'NOT_HERE_TO_POST') {
    return values.slice(1);
  }

  // User has a preferred listing type selected then selected "NOT_HERE_TO_POST"
  if (values.includes('NOT_HERE_TO_POST')) return ['NOT_HERE_TO_POST'];

  return values;
}
